<app-search-result-card>
  <backstage-color-bg-icon
    class="align-self-start mb-3"
    color="red"
    iconName="book"
    ngbTooltip="Workbook"
  ></backstage-color-bg-icon>
  <app-ellipsis [lines]="2" class="course-name-wrapper mb-1">
    <a
      class="fw-semibold small text-decoration-none text-gray-600"
      [href]="result.learningPathId | universityLearningPathUrl">
      <span class="material-symbols-outlined">route</span>
      {{ result.learningPathName }}
    </a>
  </app-ellipsis>
  <app-ellipsis class="mb-2" [lines]="3">
    <a
      [appSearchResultLink]="result"
      [href]="result.url"
      class="h5 text-decoration-none text-lightblue-700">{{ result.title }}</a>
  </app-ellipsis>
  <app-ellipsis [lines]="4">
    <div class="small text-gray-500" [innerHTML]="result.synopsis"></div>
  </app-ellipsis>
</app-search-result-card>
